import { render, staticRenderFns } from "./DataFormInputMultiselect.vue?vue&type=template&id=27583258&"
import script from "./DataFormInputMultiselect.vue?vue&type=script&lang=js&"
export * from "./DataFormInputMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./DataFormInputMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports